module.exports = __webpack_public_path__ + "static/media/connell.280bbb95.jpeg";